module.exports = __webpack_public_path__ + "img/ZE.556b5ce4.png";